/**
 * Leitura de cookie no navegador.
 *
 * Usada apenas para o token ANTI-CSRF (`ponto_certo_csrf`), que o backend
 * entrega deliberadamente sem HttpOnly para que o cliente consiga reenviá-lo
 * no header `X-CSRF-Token`.
 *
 * O cookie de SESSÃO é HttpOnly e nunca é (nem pode ser) lido aqui.
 */
export function readCookie(name: string): string | null {
  if (typeof document === "undefined") return null;

  const prefix = `${name}=`;
  const found = document.cookie
    .split("; ")
    .find((row) => row.startsWith(prefix));

  if (found === undefined) return null;

  return decodeURIComponent(found.slice(prefix.length));
}
